import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import {
  CreateGameBaseUrlInput,
  GameBaseUrl,
  UpdateGameBaseUrlInput,
} from './game-base-urls-types';

const KEYS = {
  all: ['game-base-urls'] as const,
  list: (gameId: string) => [...KEYS.all, gameId] as const,
};

export function useGameBaseUrls(gameId: string) {
  return useQuery({
    queryKey: KEYS.list(gameId),
    queryFn: async () => {
      const r = await apiClient.get<GameBaseUrl[]>(`/admin/games/${gameId}/base-urls`);
      return r.data;
    },
    enabled: !!gameId,
  });
}

export function useCreateGameBaseUrl(gameId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateGameBaseUrlInput) =>
      apiClient.post<GameBaseUrl>(`/admin/games/${gameId}/base-urls`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.list(gameId) }),
  });
}

export function useUpdateGameBaseUrl(gameId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateGameBaseUrlInput }) =>
      apiClient.patch<GameBaseUrl>(`/admin/games/${gameId}/base-urls/${id}`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.list(gameId) }),
  });
}

export function useDeleteGameBaseUrl(gameId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiClient.delete(`/admin/games/${gameId}/base-urls/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.list(gameId) }),
  });
}
